import { db } from "../Status/FirebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import {ProfileDataType} from '../../Constants'

export const UpdateUserMetadata = (inputData: ProfileDataType, uid: string) => {
    return setDoc(doc(db, "identity", "users", "account_metadata", uid), inputData)
}